export default [
  {
    id: 1,
    title: "Taj Mahal",
    location: "India",
    googleMapsUrl: "https://goo.gl/maps/nBCFsKKB9niyn4dD6",
    startDate: "12 Jan, 2021",
    endDate: "24 Jan, 2021",
    description:
      "The Taj Mahal, is an Islamic ivory-white marble mausoleum on the right bank of the river Yamuna in the Indian city of Agra. It was commissioned in 1631 by the Mughal emperor Shah Jahan to house the tomb of his favourite wife, Mumtaz Mahal",
    imageUrl:
            "https://cdn.pixabay.com/photo/2015/07/29/22/56/taj-mahal-866692_960_720.jpg",
     explore: "https://en.wikipedia.org/wiki/Taj_Mahal",
    },
  {
    id: 2,
    title: "Niagra Fall",
    location: "USA",
    googleMapsUrl: "https://goo.gl/maps/u9u48weRRx5NmfDu6",
    startDate: "12 Jan, 2021",
    endDate: "24 Jan, 2021",
    description:
      "Niagara Falls is a group of three waterfalls at the southern end of Niagara Gorge, spanning the border between the province of Ontario in Canada and the state of New York in the United States. The largest of the three is Horseshoe Falls, which straddles the international border of the two countries.",
    imageUrl:
          "https://cdn.pixabay.com/photo/2016/08/13/07/20/niagara-1590345_960_720.jpg",
    explore:"https://en.wikipedia.org/wiki/Niagara_Falls",
  },
  {
    id: 3,
    title: "Pyramid",
    location: "Egypt",
    googleMapsUrl: "https://goo.gl/maps/FncfW4sLxuYhz94J7",
    startDate: "12 Jan, 2021",
    endDate: "24 Jan, 2021",
    description:
      "A pyramid is a structure whose outer surfaces are triangular and converge to a single step at the top, making the shape roughly a pyramid in the geometric sense. The base of a pyramid can be trilateral, quadrilateral, or of any polygon shape.",
    imageUrl:
      "https://cdn.pixabay.com/photo/2018/06/16/10/10/pyramid-3478575_960_720.jpg",
    explore: "https://en.wikipedia.org/wiki/Pyramid",
  },
  {
    id: 4,
    title: "Eiffel Tower",
    location: "Paris",
    googleMapsUrl: "https://goo.gl/maps/28CnR3pkT9iT7HxP7",
    startDate: "12 Jan, 2021",
    endDate: "24 Jan, 2021",
    description:
      "The Eiffel Tower is a wrought-iron lattice tower on the Champ de Mars in Paris, France. It is named after the engineer Gustave Eiffel, whose company designed and built the tower. Locally nicknamed La dame de fer, it was constructed from 1887 to 1889 as the centerpiece of the 1889 World's Fair.",
    imageUrl:
          "https://cdn.pixabay.com/photo/2018/04/25/09/26/eiffel-tower-3349075_960_720.jpg",
    explore: "https://en.wikipedia.org/wiki/Eiffel_Tower",
  },
  {
    id: 5,
    title: "Great Wall Of China",
    location: "China",
    googleMapsUrl: "https://goo.gl/maps/E2WdW8Qxvy2cuqQx8",
    startDate: "12 Jan, 2021",
    endDate: "24 Jan, 2021",
    description:
      "The Great Wall of China is a series of fortifications that were built across the historical northern borders of ancient Chinese states and Imperial China as protection against various nomadic groups from the Eurasian Steppe.",
    imageUrl:
          "https://cdn.pixabay.com/photo/2013/11/28/10/36/painting-220060_960_720.jpg",
    explore:"https://en.wikipedia.org/wiki/Great_Wall_of_China",
  },
  {
    id: 6,
    title: "Ajanta Caves",
    location: "India",
    googleMapsUrl: "https://goo.gl/maps/bvtSZr4rEJmZGgyHA",
    startDate: "12 Jan, 2021",
    endDate: "24 Jan, 2021",
    description:
      "The Statue of Unity is the world's tallest statue, with a height of 182 metres, located near Kevadia in the state of Gujarat, India. It depicts Indian statesman and independence activist Vallabhbhai Patel, who was the first deputy prime minister and home minister of independent India.",
    imageUrl:
          "https://cdn.pixabay.com/photo/2017/06/22/19/21/ajanta-2432144_960_720.jpg",
    explore:"https://en.wikipedia.org/wiki/Ajanta_Caves",
  },
  {
    id: 7,
    title: "Statue Of Unity",
    location: "India",
    googleMapsUrl: "https://goo.gl/maps/veXgLiV7Yeo2PTcr5",
    startDate: "12 Jan, 2021",
    endDate: "24 Jan, 2021",
    description:
      "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists.",
    imageUrl:
          "https://cdn.pixabay.com/photo/2021/10/03/14/34/statue-6678155_960_720.jpg",
    explore:"https://en.wikipedia.org/wiki/Statue_of_Unity",
  },
  {
    id: 8,
    title: "Rome Collosseum",
    location: "Rome",
    googleMapsUrl: "https://goo.gl/maps/HqXkg2bFRrvUq9ti8",
    startDate: "12 Jan, 2021",
    endDate: "24 Jan, 2021",
    description:
      "The Colosseum is an oval amphitheatre in the centre of the city of Rome, Italy, just east of the Roman Forum. It is the largest ancient amphitheatre ever built, and is still the largest standing amphitheatre in the world today.",
    imageUrl:
          "https://cdn.pixabay.com/photo/2017/02/24/01/10/rome-2093608_960_720.jpg",
    explore:"https://en.wikipedia.org/wiki/Colosseum",
    },
];
